module.exports = __webpack_public_path__ + "img/sc.0fd2ca7c.png";